import * as React from 'react';
import { FC } from 'react';
import { useContext, FormContext } from './useFormContext';

type BankNamesProps = { context: FormContext; currency: string };

const BankNames: FC<BankNamesProps> = ({ currency }) => {
  const {
    locales,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    extra: { bank_names, selected_bank_name },
  } = useContext();
  const banks = bank_names[currency];

  if (!banks?.length) return null;

  return (
    <div className="rs-column-small-12">
      <label htmlFor="bank_name">{`${locales.bank_names_label}:`}</label>
      <select name="bank_name" id="bank_name" defaultValue={selected_bank_name}>
        {banks.map((bank) => (
          <option key={bank} value={bank}>
            {bank}
          </option>
        ))}
        <option value="">{locales.other_bank}</option>
      </select>
    </div>
  );
};

export default BankNames;
